import React from 'react';
import PagePanel from './PagePanel';
import { Button, Panel } from 'react-bootstrap';

const ResourcePanel = props => (
  <div>
    <a href={props.url} target="_blank">{props.title}</a>:&nbsp;
    {props.content}
  </div>
);

const makeResources = resources => (
  <ul>
    { resources.map((resource, idx) => (
        <li>
          <ResourcePanel {...resource} />
        </li>
      )
    ) }
  </ul>
);

const resources = [
  {
    title: "Accounting in the Headlines blog",
    content: "If you need short cases for introductory financial or managerial accounting, check out my blog. Approximately one to two short real-life stories are added each week, including discussion questions. Use the navigation bar on the right, you can click specific topics to narrow your choices.",
    url: "https://accountingintheheadlines.com/",
  },
  {
    title: "IMA Educational Case Journal",
    content: "This publication includes two to four cases and is published by the Institute of Management Accountants four times a year. If you are an IMA member, you can log in to get the teaching notes for each case. I highly recommend this publication for cases to use in class, especially at the MBA level.",
    url: "https://www.imanet.org/educators/ima-educational-case-journal",
  }
];

const InstructorNotesPage = props => (
  <PagePanel>
    <h3>Teaching Notes</h3>
    <p>Student engagement almost always increases when students are interested in the assignment. Using real-life companies helps to build student engagement.</p>
    <p><b>Why not use the same case for all students?</b></p>
    <p>If you use the same case for all students, a few issues may arise:</p>
    <ol>
      <li>Student groups may borrow content from other groups;</li>
      <li>In-class presentations are problematic because each group would be presenting the same case; </li>
      <li>The companies or industry featured in the class case may not interest some of the students;</li>
      <li>Case solutions can be passed from students in one semester’s class to the next semester; and</li>
      <li>Case solutions might be found on the internet. </li>
    </ol>
    <p>By using the Accounting Case assignment, several of these issues are resolved. Student groups are each working on unique industries and companies, minimizing borrowing of content. Since every group has different industries and companies, the in-class presentations are varied and interesting.  Students get to choose an industry and companies that interest them, increasing their engagement in the class. Case solutions cannot be passed from one semester to the next since new industries and companies are chosen. As each reporting year goes by, new Form 10-Ks form the basis of the case, making older case solutions outdated.</p>
    <p><b>Ways I have used the Accounting Case assignment</b></p>
    <p>The Accounting Case Template is built to be modular; you can select just the sections you want for the assignment. You also can specify if you want written papers, presentations, or both. As an instructor, your time to prepare the case assignment is minimized. You click on the options in the Accounting Case Template and then download a Word document that is ready for you to review and then assign. </p>
    <p>In my own classes, I have used the Accounting Case assignment in a few different ways, including:</p>
    <ol>
      <li>Traditional written paper with groups of 2-3 students</li>
      <li>Oral presentations by each group throughout the semester (on different topics), culminating in a final overview presentation by each group</li>
      <li>Video presentations assigned to groups of students in an online class with classmates viewing and evaluating the presentations</li>
      <li>Topics posted to online discussion boards, with individual students selecting one company each</li>
    </ol>
    <h3>Other Case Resources</h3>
    { resources.map(resource => (<ResourcePanel {...resource} />)) }

  </PagePanel>
);

export default InstructorNotesPage;



// WEBPACK FOOTER //
// ./src/components/InstructorNotesPage.js